import React from 'react';
import { Globe } from 'lucide-react';
import { PropertyStatus } from '../../types/property';
import { cn } from '../../lib/utils';

interface PropertyStatusBadgeProps {
  status: PropertyStatus;
  isPublished?: boolean;
  className?: string;
}

export const PropertyStatusBadge: React.FC<PropertyStatusBadgeProps> = ({
  status,
  isPublished,
  className
}) => {
  const getTransactionLabel = (status: PropertyStatus) => {
    switch (status) {
      case 'for-sale':
        return 'Vente';
      case 'for-rent':
        return 'Location';
      case 'for-short-rent':
        return 'Location courte durée';
      case 'estimation':
        return 'Estimation';
      case 'sold':
        return 'Vendu';
      case 'rented':
        return 'Loué';
      case 'archived':
        return 'Archivé';
      default:
        return '';
    }
  };

  const getStatusColor = (status: PropertyStatus) => {
    switch (status) {
      case 'for-sale':
        return 'bg-blue-500/90 text-white';
      case 'for-rent':
        return 'bg-green-500/90 text-white';
      case 'for-short-rent':
        return 'bg-orange-500/90 text-white';
      case 'estimation':
        return 'bg-purple-500/90 text-white';
      case 'sold':
        return 'bg-green-500/90 text-white';
      case 'rented':
        return 'bg-green-600/90 text-white';
      case 'archived':
        return 'bg-gray-500/90 text-white';
      default:
        return 'bg-gray-500/90 text-white';
    }
  };

  // Vérifier si le bien doit afficher l'icône de publication
  const shouldShowPublicationIcon = () => {
    // L'icône ne doit s'afficher que si le bien est effectivement publié (is_published = true)
    // et seulement pour les biens qui peuvent être publiés
    const canBePublished = ['for-sale', 'for-rent', 'for-short-rent'].includes(status);
    
    // Vérification stricte : isPublished doit être explicitement true ou 1
    const isExplicitlyPublished = Boolean(isPublished);
    
    console.log('Publication check:', {
      status,
      canBePublished,
      isPublished,
      isExplicitlyPublished,
      shouldShow: canBePublished && isExplicitlyPublished
    });
    
    return canBePublished && isExplicitlyPublished;
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className={cn("rounded-full px-2 py-1 text-xs font-medium shadow-sm", getStatusColor(status))}>
        {getTransactionLabel(status)}
      </span>
      {shouldShowPublicationIcon() && (
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/90 shadow-sm dark:bg-gray-800/90">
          <Globe className="h-3.5 w-3.5 text-primary-500" />
        </span>
      )}
    </div>
  );
};